import { useState, useEffect } from "react";

interface WindowSize {
  windowWidth: number | undefined;
}

const useWindowResize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    windowWidth: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        windowWidth: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);

    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default useWindowResize;
